// extracted by mini-css-extract-plugin
export default {"editor":"QuillEditor_editor__rLLYj","viewer":"QuillEditor_viewer__9AV75"};